import { render } from "./variant-collection-slideout-trigger.vue?vue&type=template&id=b530856c"
import script from "./variant-collection-slideout-trigger.vue?vue&type=script&lang=js"
export * from "./variant-collection-slideout-trigger.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__